import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!

  return (_openBlock(), _createBlock(_component_loader, { task: _ctx.task }, {
    default: _withCtx(({ loading }) => [
      _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps({ loading })))
    ]),
    _: 3
  }, 8, ["task"]))
}